import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { confirm, toHours } from '../../helpers/helpers';

// Translations
import translate from '../Translate.js';

const ReviewPackages = observer(class ReviewPackages extends React.Component {
  constructor() {
    super();
    this.claimPackage = this.claimPackage.bind(this);
    this.openPackage = this.openPackage.bind(this);
  }

  componentWillMount() {
    this.state = {
      packageClaimed: false,
      packageUrl: null
    }
  }

  claimPackage(packageSid) {
    const { translation } = this.props;

    const msg = {
      heading: translation.confirm.heading,
      body: translation.confirm.body,
      button: translation.confirm.button,
    }

    confirm(msg, () => this.openWindow(packageSid));
  }

  openWindow(packageSid) {
    const { ReviewStore } = this.props.store;

    this.reviewWindow = window.open('', '_blank');

    ReviewStore.claimPackage(packageSid, this.openPackage);
  }

  openPackage() {
    const { selectedPackageSids } = this.props.store.ReviewStore;
    const _this = this;

    // Create a query param out of the selected package sids
    let query = '?sid='

    for(let i = 0; i < selectedPackageSids.length; i++) {
      if(i > 0) {
        query += ','
      }

      query += selectedPackageSids[i]
    }

    const url = `https://s3.amazonaws.com/smarterservices-static/virtual-test-center-session-playback/index.html${query}`;

    this.setState({
      packageClaimed: true,
      packageUrl: url
    }, function(){
      _this.reviewWindow.location.href = url;
    });
  }

  render() {
    const { translation } = this.props;
    const { packages } = this.props.store.ReviewStore;

    return (
      <div className="cta">
        <strong className="cta__copy">{translation.heading}</strong>

        <span className="cta__subcopy">
          {translation.body.replace('%duration%', toHours(packages[0].longestSession, false, true, true))}
        </span>

        {!this.state.packageClaimed &&
          <button
            className="cta__btn"
            onClick={() => this.claimPackage(packages[0].reviewPackageSid)}
          >
            {translation.button}
          </button>
        }

        {this.state.packageClaimed && this.state.packageUrl &&
          <a
            className="cta__btn"
            href={this.state.packageUrl}
            target="_blank"
          >
            {translation.button}
          </a>
        }
      </div>
    );
  }
})

export default translate('ReviewPackages')(ReviewPackages);



// WEBPACK FOOTER //
// ./src/app/components/Dashboard/ReviewPackages.js